module.exports = __webpack_public_path__ + "static/media/google-logo.edd0e34f.svg";